import { get } from 'lodash'
import { connect } from 'react-redux'

import InitialForm from './component'

export const mapStateToProps = state => ({
  formError: get(state, 'formSettings.formError'),
})

export default connect(mapStateToProps)(InitialForm)
